<template>
  <div class="category-ui" :class="{'category-card':datas.borderType=='isCard'}" :style="styleBg">
    <div class="scroll-category" v-if="datasNew.showType == 'slide' &&(datas.layout == 'fourfor' || datas.layout == 'fivefor')">
      <div class="category category-scroll" @scroll="scrollCategory" ref="scrollable">
        <div class="category-box" :style="{ minWidth: scrollWidth + '%' }">
          <div class="category-item" :class="datas.layout" v-for="(item, index) in datas.items" :key="index" @click="toCategary(item)">
            <img :src="item.url" />
            <p :style="style">{{ item.name }}</p>
          </div>
        </div>
      </div>

      <div class="speed-box" v-if="scrollWidth > 100">
        <div class="speed" :style="speed"></div>
      </div>
    </div>
    <div class="category-swiper" v-else-if="(datas.isSwiper || datasNew.showType == 'lb')&&(datas.layout =='fourfor'||datas.layout =='fivefor')">

      <div class="swiper-box swiper-wrapper" @change="swiperChange">
        <div class="category swiper-slide" :class="datas.layout" v-for="(item, i) in Math.ceil(datas.items.length/swiperNum)" :key="i">
          <div class="category-item" :class="datas.layout" v-for="(item, index) in datas.items" :key="index" @click="toCategary(item)" v-if="index>=i*swiperNum&&index<(i+1)*swiperNum">
            <img :src="item.url">
            <p :style="style">{{item.name}}</p>
          </div>
        </div>
      </div>
      <div class="dots">

      </div>
    </div>
    <ul class="category" v-else>
      <li class="category-item" :class="datas.layout" v-for="(item, index) in datas.items" :key="index" @click="toCategary(item)">
        <img :src="item.url" alt />
        <p :style="style">{{item.name}}</p>
      </li>
    </ul>
    <div class="btBtn-box" v-if="datas.showBt">
      <div class="btBtn" :style="btnStyle" @click="toPage">{{datas.btText}}</div>
    </div>
    <serviceQcode ref="serviceQcode"></serviceQcode>
  </div>
</template>

<script>
import {
  jAlert3
} from "@/base/jAlert/jAlert";
import {
  getStorage
} from '@/utils/wxuser';
import serviceQcode from "@/components/serviceQcode";
import Swiper from "swiper";
export default {
  name: "Category",
  props: ["datas"],
  data() {
    return {
      swiperNum: 8,
      swiperCurrent: 0,
      swiper: null,
      speed: "left:0;",
      datasNew:{}
    };
  },
  computed: {

    scrollWidth() {
      var width = 0;
      if (this.datas.layout == "fourfor") {
        width = 25;
      }
      if (this.datas.layout == "fivefor") {
        width = 20;
      }
      var allWidth = Math.ceil(this.datas.items.length / 2) * width;

      return allWidth;
    },
    styleBg() {
      var style = `background:${this.datas.bgColor};`
      if (this.datas.moduleShadow) {
        style += `box-shadow: rgba(48, 48, 48, 0.1) 0px 6px 12px 0px;`
      }
      return style
    },
    style() {
      var style = "";
      if (this.datas.color) {
        style += `color:${this.datas.color};`;
      }
      if (this.datas.fontSize) {
        style += `font-size:${this.datas.fontSize};`;
      }
      return style;
    },
    btnStyle() {
      var style = `background:${this.datas.btColor};`
      if (this.datas.btShadow) {
        style += `box-shadow: 0px 7px 14px 0px ${this.datas.btColor}20;`
      }
      return style;
    }
  },
  components: {
    serviceQcode
  },

  methods: {
    scrollCategory(e) {

      this.speed = `left:${(e.target.scrollLeft / (e.target.scrollWidth - e.target.offsetWidth)) * (1 - 18 / 35) * 100}%;`;
    },
    initSwiper() {
      this.swiper = new Swiper(".category-swiper", {
        autoplay: true,
        paginationClickable: true,
        autoplayDisableOnInteraction: true, // 处理手动滑动后，继续自动滑动
        loop: false,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".dots",
        },
      });
    },
    toPage() {
      if (this.datas.btLink) {
        this.goLink(this.datas.btLink)

      }
    },
    toCategary(item) {
      if (item.name === "客服") {
        if (getStorage('isQrCode')) {
          this.$refs.serviceQcode.isServiceQcode = true
        } else if (item.link) {
          window.location.href = "tel:" + item.link
        }
        return;
      } else {
        if (item.link != "") {
          if (item.link.indexOf('http') != -1) {
            this.goLink(item.link)
          } else {
            jAlert3(item.link)
            return;
          }

        }
      }
    },

  },

  created() {
    this.datasNew = this.datas;
    if (this.datas.layout == 'twofor') {
      this.swiperNum = 4
    }
    if (this.datas.layout == 'threefor') {
      this.swiperNum = 6

    }
    if (this.datas.layout == 'fourfor') {
      this.swiperNum = 8
      if (this.datasNew.items.length <= 8 && this.datasNew.showType == "slide") {
        this.datasNew.showType = "";
      }
      if (this.datas.isSwiper || this.datas.showType == 'lb') {
        this.$nextTick(() => {
          this.initSwiper()
        })

      }
    }
    if (this.datas.layout == 'fivefor') {
      this.swiperNum = 10
      if (this.datasNew.items.length <= 10 && this.datasNew.showType == "slide") {
        this.datasNew.showType = "";
      }
      if (this.datas.isSwiper || this.datas.showType == 'lb') {
        this.$nextTick(() => {
          this.initSwiper()
        })

      }
    }

  },
};
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.category-ui {
  &.category-card {
    margin: 0 0.4rem;
    background: #fff;
    border-radius: 0.48rem;
    padding: 0.266667rem 0;
  }
}

.btBtn-box {
  padding: 0.533333rem;

  .btBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.666667rem;
    color: #fff;
    height: 1.333333rem;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #ffffff;
    text-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    font-weight: bold;
  }
}
.scroll-category {
  padding: 10px 0 15px;
}
.speed-box {
  position: relative;
  margin: 10px auto 0;
  width: 35px;
  height: 4px;
  border-radius: 2px;
  background: #e9e9e9;
  overflow: hidden;
  .speed {
    position: absolute;
    height: 4px;
    width: 18px;
    border-radius: 2px;
    top: 0;
    background: @color-theme;
  }
}

.category {
  display: flex;
  flex-wrap: wrap;

  &.category-scroll {
    overflow-x: auto;
    white-space: nowrap;
    .category-item {
      &.fourfor {
        min-width: 25vw;
        width: 25vw;
      }

      &.fivefor {
        min-width: 20vw;
        width: 20vw;
      }
    }
    .category-box {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .category-item {
    text-align: center;
    padding: 0.213333rem 0;
    min-width: 20%;

    img {
      width: 1.333333rem;
      height: 1.333333rem;
    }

    p {
      overflow: hidden;
      margin-top: 0.16rem;
      font-size: 14px;
      line-height: 1;
      text-overflow: ellipsis;
      color: #333333;
    }

    &.twofor {
      width: 50%;
    }

    &.threefor {
      width: 33.333333%;
    }

    &.fourfor {
      width: 25%;
    }

    &.fivefor {
      width: 20%;
    }
  }
}

/deep/.category-swiper {
  padding: 10px 0 15px;
  position: relative;

  .swiper-pagination-bullets {
    // position: absolute;
    margin: 10px auto 0;
    left: 50%;

    display: flex;
    justify-content: center;

    .swiper-pagination-bullet {
      margin: 0 0.05332rem;
      width: 4px;
      height: 4px;
      border-radius: 2px;
      background: #eee;
      transition: all 0.6s;
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      width: 0.7998rem;

      position: relative;
      background: @color-theme;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Category.vue